<script lang="ts" context="module">

    //Fecha de referencia para considerar una foto antigua
    const refOldDate = new Date(2022, 3, 28);

</script>

<script lang="ts">
    
    import { onDestroy, onMount } from "svelte";
    import type { Fn, PictureDto, PictureUploadEventDto } from "../../global";
    import { getLastPictureByLabels, pictureUploads } from "../../Services/pictures";

    export let milestoneId: string;

    let unsubPictureUploads: Fn;
    let picture: PictureDto;
    let isLoading = true;

    $: getLastPicture(milestoneId);

    onMount(() => {
        unsubPictureUploads = pictureUploads.subscribe(onPictureUpload);
    });

    onDestroy(() => {
        unsubPictureUploads();
    });

    async function getLastPicture(milestoneId: string): Promise<void> {
        try {
            isLoading = true;
            picture = await getLastPictureByLabels([milestoneId]);
        } finally {
            isLoading = false;
        }
    }

    function isOld(picture: PictureDto): boolean {
        return picture.createdDate < refOldDate;
    }

    function onPictureUpload(event: PictureUploadEventDto): void {
        if (milestoneId !== event.milestoneId) {
            return;
        }
        getLastPicture(milestoneId);
    }

</script>

<div class="last-milestone-picture">
    {#if isLoading}
        <div class="loading">
            Cargando...
        </div>
    {/if}
    {#if picture}
        <img class="picture" class:is-old={isOld(picture)} src={picture.url.small} alt="">
        <div class="over">
            {#if 'user_name' in picture.meta}
            <div class="user">
                {#if 'user_image' in picture.meta}
                    <img class="user-image" src={picture.meta.user_image} alt="">
                {/if}
                <div class="user-name">{picture.meta.user_name}</div>
            </div>
                <div class="user-name"></div>
            {/if}
            {#if isOld(picture)}
                <div class="be-the-first">
                    <img class="icon" src="/images/camera.svg" alt="">
                    <div class="text">Sé el primero o primera en subir una foto actualizada</div>
                </div>
            {/if}
        </div>
    {/if}
</div>

<style lang="scss">

    .last-milestone-picture {
        position: relative;
        height: 100%;
    }

    .loading {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .picture {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;

        &.is-old {
            filter: saturate(0) contrast(0.7);
            // filter: saturate(0.8) sepia(0.5) contrast(0.8);
        }
    }

    .over {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        box-sizing: border-box;
    }

    .user {
        display: flex;
        gap: 5px;
        padding: 5px;

        .user-image {
            width: 20px;
            height: 20px;
            object-fit: cover;
            border-radius: 50%;
        }
    }

    .be-the-first {
        padding: 5px;
        display: flex;
        align-items: center;
        gap: 5px;

        .icon {
            width: 30px;
            height: 30px;
            object-fit: contain;
        }
    }

</style>
